import React from 'react';
import { Card, Typography, List, ListItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';

const InfoListCard = ({ title, items, sections }) => {
  // Si sections est fourni, on affiche plusieurs sections dans la même carte
  if (sections && Array.isArray(sections)) {
    return (
      <Card
        sx={{
          p: 3,
          backgroundColor: '#e9eff7',
          height: '100%',
          borderRadius: '8px',
          border: 0,
          boxShadow: 'none',
          width: '100%',
          
        }}
      >
        {sections.map((section, idx) => (
          <Box key={idx} sx={{ mb: idx < sections.length - 1 ? 3 : 0 }}>
            {section.title && (
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#0C3058', mb: 0 }}>
                {section.title}
              </Typography>
            )}
            <List dense>
              {section.items.map((item, i) => (
                <ListItem sx={{ px: 0 }} key={i}>
                  <ListItemIcon sx={{ minWidth: 24 }}>
                    <FiberManualRecord sx={{ fontSize: 10, color: '#FF6B35' }} />
                  </ListItemIcon>
                  <ListItemText primary={item} />
                </ListItem>
              ))}
            </List>
          </Box>
        ))}
      </Card>
    );
  }

  // Sinon, comportement simple (un seul titre + liste)
  return (
    <Card
      sx={{
        p: 3,
        backgroundColor: '#e9eff7',
        height: '100%',
        borderRadius: '8px',
        border: 0,
        boxShadow: 'none',
        width: '100%',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 700, color: '#0C3058', mb: 0 }}>
        {title}
      </Typography>
      <List dense>
        {items && items.map((item, idx) => (
          <ListItem sx={{ px: 0 }} key={idx}>
            <ListItemIcon sx={{ minWidth: 24 }}>
              <FiberManualRecord sx={{ fontSize: 10, color: '#FF6B35' }} />
            </ListItemIcon>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>
    </Card>
  );
};

export default InfoListCard; 